// EditPanel.tsx - This file now re-exports EditorPanel for backwards compatibility
// All logic has been refactored into the EditorPanel folder structure:
// - EditorPanel/EditorPanel.tsx - Main component
// - EditorPanel/constants.ts - Constants and mappings
// - EditorPanel/helpers.ts - Helper functions
// - EditorPanel/imageUtils.ts - Image processing utilities
// - EditorPanel/pdfGenerator.ts - PDF generation
// - EditorPanel/coverGenerator.ts - Cover generation
// - EditorPanel/components/ - Subcomponents (PhotoPopup, BlankPopup, AnswerCorrection)

import EditorPanel from "./EditorPanel";

export default EditorPanel;
